// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RDd0","input":"styles_input__vz3Xc"};